import { get, patch, put } from "../../utils/request";

export const getHeadersProducts = async (name, key) => {
  const res = await get(`headers-products?gender=${name}&key=${key}`);
  return res;
};

export const getCondition = async () => {
  const res = await get("condition");
  return res;
};

export const updateHeaderProductByKey = async (key, productId, newPrice) => {
  const headerRes = await get(`headers-products?key=${key}`);

  if (!headerRes || headerRes.length === 0) {
    throw new Error("Header không tồn tại hoặc sai key");
  }

  const header = headerRes[0];

  const updatedProducts = (header.products || []).map((product) =>
    product.idProducts === productId
      ? { ...product, price_old: newPrice, sales: 0 }
      : product
  );

  const updatedHeader = {
    ...header,
    products: updatedProducts,
  };

  const res = await put(`headers-products/${header.id}`, updatedHeader);

  return res;
};

export const getHeaderByProductId = async (productId) => {
  const headers = await get(`headers-products`);
  if (!headers || headers.length === 0) {
    throw new Error("Không có headers nào");
  }

  const header = headers.find((h) =>
    h.products?.some((p) => p.idProducts === productId)
  );

  if (!header) {
    throw new Error("Không tìm thấy header chứa sản phẩm này");
  }

  return header;
};

export const getHeadersProductsByFilter = async (key, params = {}) => {
  const res = await get(`headers-products?key=${key}`);

  if (!res || res.length === 0) return [];

  const header = res[0];

  let products = header.products || [];

  // --- FILTER FE ---
  if (params.q) {
    const qLower = params.q.toLowerCase();
    products = products.filter(
      (p) =>
        p.name.toLowerCase().includes(qLower) ||
        p.color.toLowerCase().includes(qLower) ||
        p.condition.toLowerCase().includes(qLower)
    );
  }

  if (params.name) {
    const n = params.name.toLowerCase();
    products = products.filter((p) => p.name.toLowerCase().includes(n));
  }

  if (params.size) {
    products = products.filter((p) => p.size === params.size);
  }

  if (params.color) {
    const c = params.color.toLowerCase();
    products = products.filter((p) => p.color.toLowerCase().includes(c));
  }

  if (params.condition) {
    const con = params.condition.toLowerCase();
    products = products.filter((p) => p.condition.toLowerCase().includes(con));
  }

  // Không dùng limit → trả full list
  return {
    ...header,
    products,
  };
};
